<div class="login-container">
  <div class="login-form">
    <h2 class="login-title">Access denied</h2>
    <p class="login-help">Your account does not have access to this application.</p>
    <button type="button" class="submit-btn" (click)="logout()">Log out</button>
  </div>
</div>
